import { Box, styled } from '@mui/material';

export const StyledHeader = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  padding: theme.spacing(1.5, 2),
  boxShadow: '0px 4px 4px rgba(15, 23, 42, 0.08)',
  backgroundColor: theme.palette.common.white,
}));
